import type { LayoutNode } from './types';

/** Compile-time exhaustiveness guard for `LayoutNode` switches. */
export function assertLayoutNodeExhaustive(value: never): never {
  throw new Error(`Unhandled layout node type: ${(value as LayoutNode).type}`);
}
